// Canais de contato da equipe E-BACKUP, os mesmos do site.

export const CONTACT = {
  whatsapp: "+55 11 92201-3261",
  whatsappNumber: "5511922013261",
  mail: "contato@e-backup.cloud",
} as const;

/** Link do WhatsApp; text abre a conversa com a mensagem já escrita. */
export function whatsappHref(text?: string): string {
  const base = `https://wa.me/${CONTACT.whatsappNumber}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}
